<template>
  <v-container>
    <v-card class="mx-auto pa-4">
      <div class="d-flex align-center">
        <p class="display-1 text--primary mb-0">
          Listings
        </p>
        <v-spacer />
        <v-switch v-if="snapshotId" v-model="showExcluded" :loading="loadingExcluded" label="Show excluded listings" hide-details class="mt-0" />
      </div>
      <v-data-table dense :headers="headers" :options.sync="options" :must-sort=true :items="displayedListings"
        :server-items-length="displayedListings.length" :footer-props="{
          itemsPerPageOptions: [-1]
        }" :item-class="rowClass" loading-text="Loading...please wait" :loading="this.loading">

        <template v-slot:item.seller.displayName="{ item }">
          <a :href="item.seller.eBayStoreURL" target="_blank">{{ item.seller.displayName }}</a>
          <v-chip v-if="item.sellerTier && item.sellerTier !== 'Normal'" x-small label class="ml-1" :color="tierColor(item.sellerTier)" dark>
            {{ item.sellerTier }}
          </v-chip>
          <v-chip v-if="item.sellerWeight != null && item.sellerWeight !== 1" x-small label outlined class="ml-1" title="Price weight">
            &times;{{ item.sellerWeight }}
          </v-chip>
        </template>

        <template v-slot:item.title="{ item }">
          <a :href="item.url" target="_blank">{{ item.title }}</a>
        </template>

        <template v-slot:item.price="{ item }">
          <span style="white-space: nowrap;"> {{ item.price | toCurrency(0) }}</span>
        </template>

        <template v-slot:item.delete="{ item }">
          <v-icon small color="error" class="pa-1" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>

        <template v-slot:item.rateSeller="{ item }">
          <v-icon v-if="item.seller.id" small color="primary" class="pa-1" title="Rate seller" @click="rateSeller(item)">
            mdi-account-star
          </v-icon>
        </template>

        <template v-slot:item.excludeSeller="{ item }">
          <v-icon small color="warning" class="pa-1" @click="excludeSeller(item)">
            mdi-account-cancel
          </v-icon>
        </template>

        <template v-slot:item.excludeListing="{ item }">
          <v-icon v-if="item.isExcluded" small color="success" class="pa-1" title="Include this listing again" @click="includeListing(item)">
            mdi-eye
          </v-icon>
          <v-icon v-else small color="warning" class="pa-1" title="Exclude this listing from current and future snapshots" @click="openExcludeDialog(item)">
            mdi-eye-off
          </v-icon>
        </template>

      </v-data-table>
    </v-card>

    <ConfirmationDialog ref="confirm" />
    <SellerSettingsDialog ref="sellerSettings" />

    <v-dialog v-model="excludeDialog.show" max-width="560">
      <v-card>
        <v-card-title>Exclude Listing</v-card-title>
        <v-card-text>
          <p>
            Exclude <strong>{{ excludeDialog.item && excludeDialog.item.title }}</strong> from this and all future snapshots?
          </p>
          <v-text-field label="Reason (optional)" v-model="excludeDialog.reason" counter="500" maxlength="500" autofocus
            @keydown.enter="excludeListing" />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="excludeDialog.show = false">Cancel</v-btn>
          <v-btn color="warning" :loading="excludeDialog.saving" @click="excludeListing">Exclude</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import { ListingsService } from '../../services/api/listings';
const apiListings = new ListingsService();
import { SellersService, SELLER_TIER_COLORS } from '../../services/api/sellers';
const apiSellerService = new SellersService();


export default {
  components: {
    ConfirmationDialog: () => import("../confirmation-dialog"),
    SellerSettingsDialog: () => import("../sellers/seller-settings-dialog")
  },
  props:
  {
    loading: Boolean,
    listings: Array,
    snapshotId: Number
  },

  data() {
    return {
      options: {},
      showExcluded: false,
      loadingExcluded: false,
      excludedListings: [],
      excludeDialog: {
        show: false,
        item: null,
        reason: '',
        saving: false
      },
      headers: [
        // HACK:  use ' d-none' (note the leading space) to hide the column.
        { text: 'ID', value: 'id', hidden: true, align: ' d-none' },

        { text: 'Seller', value: 'seller.displayName' },
        { text: 'Rate Seller', value: 'rateSeller', align: 'center', sortable: false },
        { text: 'Exclude Seller', value: 'excludeSeller', align: 'center', sortable: false },
        { text: 'Title', value: 'title' },
        { text: 'Price', value: 'price', align: 'end' },
        { text: 'Qty Remaining', value: 'quantityRemaining', align: 'end' },
        { text: 'Condition', value: 'condition' },
        { text: 'Location', value: 'location' },
        { text: 'Exclude Listing', value: 'excludeListing', align: 'center', sortable: false },
        { text: 'Delete', value: 'delete', align: 'center', sortable: false }
      ],
    }
  },

  computed: {
    displayedListings() {
      const listings = this.listings || [];
      return this.showExcluded ? listings.concat(this.excludedListings) : listings;
    }
  },

  watch: {
    listings(newVal) {
      for (const item of newVal || []) {
        this.normalizeListing(item);
      }
      if (this.showExcluded) {
        this.loadExcludedListings();
      }
    },
    showExcluded(newVal) {
      if (newVal) {
        this.loadExcludedListings();
      } else {
        this.excludedListings = [];
      }
    },
    options(newVal) {
      console.log("options changed:", newVal);
      let sortBy = null;
      let sortDesc = false;
      if (newVal && Array.isArray(newVal.sortBy) && newVal.sortBy.length > 0) {
        sortBy = newVal.sortBy[0];
      }
      if (newVal && Array.isArray(newVal.sortDesc) && newVal.sortDesc.length > 0) {
        sortDesc = newVal.sortDesc[0];
      }
      this.$emit('update:options', { 
        sortBy,
        sortDesc
      });
    }
  },

  methods: {

    normalizeListing(item) {
      // Ensure that the seller object is always present.
      if (!item.seller) {
        item.seller = { displayName: "[ No Seller Info ]", eBayStoreURL: "#" };
      } else {
        if (!item.seller.displayName) {
          item.seller.displayName = item.seller.eBayStoreName || item.seller.userID || '[ No Seller Info ]';
        }
      }
    },

    tierColor(tier) {
      return SELLER_TIER_COLORS[tier] || 'grey';
    },

    rowClass(item) {
      return item.isExcluded ? 'excluded-listing' : '';
    },

    async loadExcludedListings() {
      if (!this.snapshotId) return;
      this.loadingExcluded = true;
      try {
        const excluded = await apiListings.getExcludedListingsForSnapshot(this.snapshotId);
        excluded.forEach(item => this.normalizeListing(item));
        this.excludedListings = excluded;
      } finally {
        this.loadingExcluded = false;
      }
    },

    async deleteItem(item) {
      // If the user confirms deletion, then:
      if (await this.$refs.confirm.open(
        "Confirm Delete",
        "Delete this Listing?",
        { okText: "Delete", okColor: "error" })) {


        apiListings.deleteListing(item.id).then((data) => {
          // remove the item in question from our data.
          const index = this.listings.indexOf(item);
          if (index > -1) {
            this.listings.splice(index, 1);

            // Alert any parent components that the Snapshot's listing values have changed.
            this.$emit('listings-changed');
          }
        });
      }
    },

    openExcludeDialog(item) {
      this.excludeDialog.item = item;
      this.excludeDialog.reason = '';
      this.excludeDialog.show = true;
    },

    async excludeListing() {
      const item = this.excludeDialog.item;
      if (!item || this.excludeDialog.saving) return;

      this.excludeDialog.saving = true;
      try {
        await apiListings.excludeListing(item.id, this.excludeDialog.reason);
        this.excludeDialog.show = false;
        this.$notify({ type: 'success', title: 'Listing excluded', text: 'It will be excluded from this and all future snapshots.' });
        this.$emit('listings-changed');
      } finally {
        this.excludeDialog.saving = false;
      }
    },

    async includeListing(item) {
      if (await this.$refs.confirm.open(
        "Include Listing",
        `Include '${item.title}' in snapshots again?`,
        { okText: "Include", okColor: "success" })) {

        await apiListings.includeListing(item.id);
        this.$emit('listings-changed');
      }
    },

    async rateSeller(item) {
      const updated = await this.$refs.sellerSettings.open(item.seller.id);
      if (updated) {
        this.$emit('listings-changed', item.seller.id);
      }
    },

    async excludeSeller(item) {
      // Confirm exclusion
      if (await this.$refs.confirm.open(
        "Exclude Seller",
        `Exclude all listings from seller '${item.seller.displayName}'?`,
        { okText: "Exclude", okColor: "warning" })) {

        await apiSellerService.excludeSeller(item.seller.id);
        this.$emit('listings-changed', item.seller.id);
      }
    }
  }
}
</script>

<style scoped>
::v-deep .excluded-listing {
  opacity: 0.55;
}
</style>